// KLV-parser (Key-Length-Value, SMPTE 336 / MISB) for metadata i ISR-video-
// strømmer (STANAG 4609). Dekoder BER-lengde, universelle 16-byte-nøkler og
// MISB 0601 «local set» (1-byte tags). Ren binær-parser (Uint8Array), ingen
// avhengigheter. Selve video-dekodingen ligger i medielaget; her tolkes metadata.
/** Dekod BER-lengde ved `offset`. Kort form (<0x80) = én byte; lang form = 0x80|N
 * fulgt av N lengde-byte (big-endian). */
export function decodeBerLength(bytes, offset = 0) {
    if (offset >= bytes.length)
        return null;
    const first = bytes[offset];
    if (first < 0x80)
        return { length: first, bytesRead: 1 };
    const n = first & 0x7f;
    if (n === 0 || offset + n >= bytes.length)
        return null; // 0x80 (ubestemt) støttes ikke
    let length = 0;
    for (let i = 0; i < n; i++)
        length = length * 256 + bytes[offset + 1 + i];
    return { length, bytesRead: 1 + n };
}
/** Parse en sekvens av universelle KLV-triplett (16-byte nøkkel + BER-lengde + verdi). */
export function parseKlv(bytes) {
    const out = [];
    let i = 0;
    while (i + 16 < bytes.length) {
        const key = bytes.slice(i, i + 16);
        const ber = decodeBerLength(bytes, i + 16);
        if (!ber)
            break;
        const start = i + 16 + ber.bytesRead;
        const end = start + ber.length;
        if (end > bytes.length)
            break; // trunkert
        out.push({ key, value: bytes.slice(start, end) });
        i = end;
    }
    return out;
}
/** Parse et MISB 0601 «local set» (1-byte tag + BER-lengde + verdi). Verdien til
 * ytre KLV-pakken sendes inn her (nøkkelen er allerede strippet). */
export function parseLocalSet(bytes) {
    const out = [];
    let i = 0;
    while (i < bytes.length) {
        const tag = bytes[i];
        const ber = decodeBerLength(bytes, i + 1);
        if (!ber)
            break;
        const start = i + 1 + ber.bytesRead;
        const end = start + ber.length;
        if (end > bytes.length)
            break;
        out.push({ tag, value: bytes.slice(start, end) });
        i = end;
    }
    return out;
}
/** Tolk en verdi som stort-endian usignert heltall (til f.eks. tidsstempel/tellere). */
export function klvUint(value) {
    let n = 0;
    for (const b of value)
        n = n * 256 + b;
    return n;
}
/** MISB 0601 UAS-datalink lokalsett-nøkkel (universell nøkkel, 16 byte). */
export const MISB_0601_UNIVERSAL_KEY = Uint8Array.from([
    0x06, 0x0e, 0x2b, 0x34, 0x02, 0x0b, 0x01, 0x01, 0x0e, 0x01, 0x03, 0x01, 0x01, 0x00, 0x00, 0x00,
]);
/** Sammenlign to nøkler byte-for-byte. */
export function keyEquals(a, b) {
    if (a.length !== b.length)
        return false;
    for (let i = 0; i < a.length; i++)
        if (a[i] !== b[i])
            return false;
    return true;
}
//# sourceMappingURL=klv.js.map